import { render, staticRenderFns } from "./customerGroupList.vue?vue&type=template&id=52910523&scoped=true&"
import script from "./customerGroupList.vue?vue&type=script&lang=js&"
export * from "./customerGroupList.vue?vue&type=script&lang=js&"
import style0 from "./customerGroupList.vue?vue&type=style&index=0&id=52910523&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52910523",
  null
  
)

export default component.exports